import { render, staticRenderFns } from "./Reseller.vue?vue&type=template&id=5aac4fea&scoped=true&"
import script from "@/views/Users/Reseller/Reseller.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Reseller/Reseller.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Reseller/reseller.scss?vue&type=style&index=0&id=5aac4fea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aac4fea",
  null
  
)

export default component.exports